import { ref } from 'vue';
import { useGetUser, CustomerMgmtTypes, useGetUserGroups } from '@ilteducation/customer-mgmt';

const user = ref<CustomerMgmtTypes.GetUserResponse | null>(null);
const lastGroupsOrganizationUid = ref<string | null>(null);
const groups = ref<CustomerMgmtTypes.GetMembershipsResponse | null>(null);

const isLoading = ref<boolean>(false);
export const useSidebarUser = () => {
  const { loadUser } = useGetUser();
  const { loadUserGroups } = useGetUserGroups();

  const getUser = async (uid: string, reFetch: boolean = false) => {
    isLoading.value = true;
    if (!user.value || user.value.uid !== uid || reFetch) {
      const updatedUser = await loadUser(uid);
      user.value = updatedUser;
    }
    isLoading.value = false;
  };

  const getUserGroups = async (uid: string, organizationUid: string, reFetch: boolean = false) => {
    isLoading.value = true;
    if (
      !user.value ||
      (user.value && user.value.uid !== uid) ||
      (organizationUid && organizationUid !== lastGroupsOrganizationUid.value) ||
      reFetch
    ) {
      const updatedUser = await loadUserGroups(uid, [organizationUid]);
      lastGroupsOrganizationUid.value = organizationUid;
      groups.value = updatedUser;
    }
    isLoading.value = false;
  };

  return {
    user,
    groups,
    isLoading,
    getUser,
    getUserGroups,
  };
};
